import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsNewsFeedEnabled() {
  return useCbhFlag(CbhFeatureFlag.NEWS_FEED_ENABLED, {
    defaultValue: false,
  });
}
